import {CookieStorage} from '@infra/api/CookieStorage/CookieStorage';
import {sendException} from '../../../../../../../observability';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const store = (id: string, value: Record<string, any>): Promise<void> =>
  CookieStorage.set(id, JSON.stringify(value), {expires: 365});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const retrieve = async (id: string): Promise<Record<string, any>> => {
  const item = (await CookieStorage.get(id)) || '{}';
  try {
    return JSON.parse(item);
  } catch (e) {
    sendException(new Error(`${e.message} item=${item}`));
    return {};
  }
};

const remove = (id: string): Promise<void> => CookieStorage.remove(id);

export {store, retrieve, remove};
